export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "账号ID", prop: "id", width: 70, slots: "id"   },
    // { label: "账号等级", prop: "grade" },
    { label: "角色", prop: "title", slots: "title" , width: 120 },
    { label: "账号", prop: "username" , width: 120 },
    // { label: "密码(已加密)", prop: "password" },
    { label: "手机号", prop: "phone_number" },
    // { label: "绑定微信openid", prop: "openid", slots: "openid", width: 150 },
    // {
    //   label: "微信绑定",
    //   prop: "saoma",
    //   slots: "saoma",
    //   width: 100,
    // },
    { label: "昵称", prop: "alias_name" },
    // { label: "账号折扣", prop: "discount", slots: "discount" },
    {
      label: "登录异常(5次冻结)",
      prop: "error",
      slots: "error",
      width: 200,
    },
    { label: "账号状态", prop: "status", slots: "status" , width: 120 },
    { label: "创建人账号", prop: "createUserName", width: 120, slots: "createUserName"  },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
